import React from "react";

const ThumbImage = ({ product }) => {
  return (
    <>
      {product?.img ? <img src={product?.img} width="100%" height="100%" /> : <span className={'p-2'}>{product?.title}</span>}
    </>
  );
};

export default ThumbImage;
